import { render, staticRenderFns } from "./MenuArchive.vue?vue&type=template&id=8495a038&scoped=true&"
import script from "./MenuArchive.vue?vue&type=script&lang=js&"
export * from "./MenuArchive.vue?vue&type=script&lang=js&"
import style0 from "./MenuArchive.vue?vue&type=style&index=0&id=8495a038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8495a038",
  null
  
)

export default component.exports